/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Fragment, useEffect, useState } from 'react'
import * as styles from '@/styles/common/ContactPopup.module.scss'
import ImageModal, {
  LINE_FRIEND_URL,
} from '@/components/Common/ImageModal'

const ContactPopup = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [isDesktopFloating, setIsDesktopFloating] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 701px)')

    const updateFloatingState = () => {
      setIsDesktopFloating(mediaQuery.matches && window.scrollY > 120)
    }

    updateFloatingState()
    window.addEventListener('scroll', updateFloatingState, { passive: true })
    mediaQuery.addEventListener('change', updateFloatingState)

    return () => {
      window.removeEventListener('scroll', updateFloatingState)
      mediaQuery.removeEventListener('change', updateFloatingState)
    }
  }, [])

  const handleClick = () => {
    if (window.matchMedia('(max-width: 700px)').matches) {
      window.location.assign(LINE_FRIEND_URL)
      return
    }

    setModalOpen(true)
  }

  return (
    <Fragment>
      <ImageModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        src="/line-popup-image.png"
        alt="LINE 登録案内"
      />

      <div className={styles.floating_container}>
        <span className={styles.floating_label} aria-hidden="true">
          LINEで案件情報を受け取る
        </span>
        <button
          type="button"
          onClick={handleClick}
          className={`${styles.send_mail} ${
            isDesktopFloating ? styles.desktop_floating : ''
          }`}
          aria-label="LINEで案件情報を受け取る"
        >
          <span className={styles.button_icon} aria-hidden="true">
            <img src="/character_btn.png" alt="" sx={{ display: 'block' }} />
          </span>
          <span className={styles.desktop_content} aria-hidden="true">
            <span className={styles.desktop_image}>
              <img src="/character_modal.png" alt="" sx={{ display: 'block' }} />
            </span>
            <span className={styles.desktop_text}>
              <span className={styles.desktop_title}>
                LINEで案件情報を受け取る
              </span>
              <span className={styles.desktop_cta}>LINEで登録</span>
              <span className={styles.desktop_caption}>
                相談はいつでも無料・キャンセルOK
              </span>
            </span>
          </span>
        </button>
      </div>
    </Fragment>
  )
}

export default ContactPopup
